import React, { Fragment, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { ButtonV1 } from 'lib'
import Layout from 'components/Layout'
import { changeActiveGroup , changeActiveSection, changeMaxActiveGroup, changeMaxActiveSection } from 'redux/userInfo'
import "./index.scss"
import { getConsent } from 'api/consent'
import { useParams } from 'react-router-dom'
import { incrementActiveStepOrder } from 'redux/conditionalRendering'
const Consents = () => {
    const dispatch = useDispatch()
    const { redirectionConfigId } = useParams();
    const activeSection =  useSelector(state=>state.userInfo.activeSection)
    const activeGroup = useSelector(state => state.userInfo.activeGroup)
    const consentId = useSelector(state => state.consentReducer.consentId)
    const config = useSelector(state => state.consentReducer.consentConfig)
    useEffect(() => {
        if (consentId) {
            dispatch(getConsent(consentId))
        }
        dispatch(changeActiveSection(1))
        dispatch(changeMaxActiveSection(1))
        dispatch(changeActiveGroup(1))
        dispatch(changeMaxActiveSection(1))
    }, [])
    
    let formStructure = {}, sections = {}

    if (config) {
        config?.wf_journey?.map(item => {
            if (item?.step === 1) {
                formStructure = { ...item?.form_structure }
            }
            return
        })        
        formStructure?.sections?.forEach((item, index) => {
            sections[item?.order] = {
              title: item?.title,
              form_groups: item?.form_groups?.map((_item, _index) => {
                return {
                  name: _item?.name,
                  group_order: _item?.order,
                  display_group: _item?.show,
                  group_length: item?.form_groups?.length,
                }
              }),
              section_order: item?.order,
              element_number: index,
              display_section: item?.show
            }
          })
    }

    const handleClick = () => {
        let nextSection = sections[activeSection]?.section_order + 1
       
        if (nextSection > Object.keys(sections).length) {
            alert("submitted successfully")
        }
        else if(activeGroup === sections[activeSection].form_groups.length){
            dispatch(changeActiveGroup(1))
            dispatch(changeMaxActiveGroup(1))
            dispatch(changeActiveSection(nextSection))
            dispatch(changeMaxActiveSection(nextSection))
        }
        else {
            dispatch(changeActiveGroup(activeGroup+1))
            dispatch(changeMaxActiveGroup(activeGroup+1))
        }
    }

    // 1. The consents will be stored in the user workflow data
    // 2. We'll be saving the _id of the consent in the workflow data
    // 3. Have a active_consent key which determines which consent to display
    // 4. Set the same key to the maxActiveSection

    if (!config) return "Loading..."
    
    return (
        <Layout nav_orientation={config?.nav_orientation} config={config} allignment_position={config?.allignment_position}>
            <div className='consents_container'>
                <h4>{sections?.section_title}</h4>
                {
                    
                    formStructure?.sections?.map((item, index) => {
                        if (item?.order === activeSection) {
                            let activeElement = sections[activeSection]?.form_groups.findIndex(item => item.group_order === activeGroup)
                            if (item.form_groups[activeElement]?.show) {
                                    return (
                                                <Fragment key={index}>
                                                    <div key={index} dangerouslySetInnerHTML={{ __html: item?.form_groups[activeElement]?.content }} />
                                                    <ButtonV1 label={"I Agree"} onClick={handleClick} className="primary_button" />
                                                </Fragment>
                                            )
                            }
                        }
                    })
                }
            </div>

        </Layout>
    )
}

export default Consents